import { useCallback } from 'react';
import { useSyncCenterSettingsWithMutation } from 'src/hooks/api/useSyncCenterSettingsWithMutation';
import { useComputedState } from 'src/hooks/useComputedState';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { Feature } from 'src/WebApiController';

export const useYourListingsInCompsSetting = () => {
  const hasYourListingsInCompsFeature = useUserHasFeature(
    Feature.YourListingsInComps
  );
  const { query, mutation } = useSyncCenterSettingsWithMutation();

  const [showUnbroadcastListingsInComps, setShowUnbroadcastListingsInComps] =
    useComputedState(query.data?.showUnbroadcastListingsInComps);

  const onSaveShowUnbroadcastListingsInCompsSetting = useCallback(() => {
    if (!hasYourListingsInCompsFeature || !query.data) {
      return;
    }
    const input = {
      ...query.data,
      showUnbroadcastListingsInComps,
    };
    mutation.mutate(input);
  }, [
    hasYourListingsInCompsFeature,
    mutation,
    query.data,
    showUnbroadcastListingsInComps,
  ]);

  return {
    enabled: hasYourListingsInCompsFeature,
    showUnbroadcastListingsInComps,
    setShowUnbroadcastListingsInComps,
    onSaveShowUnbroadcastListingsInCompsSetting,
  };
};
